<div class="app-root-layout">
  <app-header [perfil]="perfil" [isMobile]="isMobile"></app-header>
    <main class="app-main">
      <router-outlet></router-outlet>
    </main>
  <app-footer [perfil]="perfil"></app-footer>
  <app-whatsapp-button [phoneNumber]="perfil?.pas_whatsapp" [pas]="perfil?.api_pas_nombre"></app-whatsapp-button>
</div>
